import React, { useState } from "react";
import config from "../../config/config";
import Header from "../directives/header";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import Footer from "../directives/footer";
import { Link, useNavigate } from "react-router-dom"; 
import "../css/howitwork.css"
import ConnectWallent from "../../Common/ConnectWallent";


const Howitwork2 = () => {
  const [activeCard, setActiveCard] = useState("investor"); 

  const handleCardClick = (type) => {
    if (activeCard === type) {
      setActiveCard(null);
    } else {
      setActiveCard(type);
      if (type === "investor") {
      } else if (type === "project") {
      }
    }
  };

  return (
    <>
      <div className="home2">
        <Header />
        <section className="herobanner position-relative">
          <div className="bgleft position-absolute top-0 bottom-0 start-0">
            <img src="assets/images/shape/bgleftshadow.svg" />
          </div>
          <Container className="pt-5 mt-4">
            <Row className="justify-content-center mb-5">
              <Col lg={10} className="text-center px-lg-5">
                <h1 className="text-white fw-bold">HOW IT WORK</h1>
                <p>
                  UNITRONIX is a next-generation blockchain investment platform
                  where Investors and Project Owners collaborate to create and
                  grow innovative projects. Investors fund high-potential
                  projects, while Project Owners get the resources they need to
                  succeed—all in a secure, transparent, and decentralized
                  ecosystem.
                </p>
              </Col>
            </Row>
            <div className="card-container">
              <Row className="justify-content-center">
                <Col lg={4} md={6} className="mb-4">
                <Link to={`${config.baseUrl}Forinvestor`} style={{ textDecoration: 'none' }}>
                  <Card
                    className={`bg-primary sameHeight ${
                      activeCard === "investor" ? "activeCard" : ""
                    }`}
                    onClick={() => handleCardClick("investor")}
                    style={{ cursor: "pointer" }}
                  >
                    <Card.Body className="">
                      <div className="text-center">
                        <div className="blueBox mb-4">
                          <img src="assets/images/icon/investor.svg" />
                        </div>
                        <div className="pt-0 z-1">
                          <div className=" mb-4">
                            <h4 className="text-white">For Investor</h4>
                          </div>
                          <p>
                            we believe that Investors are the backbone of
                            innovation. By providing capital to promising
                            blockchain projects, you help drive technological
                            advancements while earning rewards, governance
                            power, and long-term growth opportunities.
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  </Link>
                </Col>
                <Col lg={4} md={6} className="mb-4">
                <Link to={`${config.baseUrl}Projectowner`} style={{ textDecoration: 'none' }}>
                  <Card
                    className={`bg-primary sameHeight ${
                      activeCard === "project" ? "activeCard" : ""
                    }`}
                    onClick={() => handleCardClick("project")}
                    style={{ cursor: "pointer" }}
                  >
                    <Card.Body className="">
                      <div className="text-center">
                        <div className="blueBox mb-4">
                          <img src="assets/images/icon/project.svg" />
                        </div>
                        <div className="pt-0 z-1">
                          <div className=" mb-4">
                            <h4 className="text-white">For Project Owner</h4>
                          </div>
                          <p>
                            We connect Project Owners with global investors
                            ready to fund high-potential blockchain projects.
                            Whether it’s DeFi, NFTs, or Web3, UNITRONIX provides
                            the tools and funding to help you scale.succeed.
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  </Link>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <section className="getintouch pt-0">
          <ConnectWallent></ConnectWallent>
        </section>
        <Footer />
      </div>
    </>
  );
};
export default Howitwork2;
